import { useEffect } from "react";
import useRequest from "../../../Hooks/useRequest";
import { getOptionDomainOrderbooks } from "../../../Requests/optionDomain";
import { GetBookOrderResponse } from "../../../Interfaces/nLegsInterfaces";
import OrderBookTable from "../../../Tables/Order/OrderBookTable";
import { StepOrderSide } from "../../../Interfaces/stepInterfaces";
import { addSeperatorToInput } from "../../../helper";
import { ISelectedTableInfo } from "../../../Interfaces/optionDomain";

interface IProps {
  selectedTableInfo: ISelectedTableInfo | null;
  totalPricesBesideOrderbooks?: boolean;
}

const Orderbook = ({
  selectedTableInfo,
  totalPricesBesideOrderbooks = false,
}: IProps) => {
  const orderBookRequest = useRequest(
    () =>
      getOptionDomainOrderbooks({
        insIds:
          selectedTableInfo && selectedTableInfo.insIds
            ? selectedTableInfo.insIds.map((i) => {
                if (i?.insId)
                  return {
                    insId: i?.insId,
                    ratio: i?.ratio,
                    side: i?.side,
                  };
                return null as any;
              })
            : [],
      }),

    (e) => {},
  );

  useEffect(() => {
    if (!selectedTableInfo) return;
    orderBookRequest.fetchData();
    const interval = setInterval(() => {
      orderBookRequest.fetchData();
    }, 10000);

    return () => clearInterval(interval);
  }, [selectedTableInfo]);

  const getOrderbookValues = (
    values?: GetBookOrderResponse[],
  ): GetBookOrderResponse[] => {
    if (!values || !values.length) return new Array(2).fill(null as any);

    if (values.length < 2) {
      const res: GetBookOrderResponse[] = [...values];
      for (let index = 0; index < 2 - values.length; index++) {
        res.push(null as any);
      }
      return res;
    }
    return values;
  };

  return (
    <div
      className={
        totalPricesBesideOrderbooks
          ? "flex flex-row justify-start items-end gap-5"
          : "flex flex-col justify-start items-start gap-1"
      }
    >
      <div className="flex flex-row justify-start items-end pt-5">
        {getOrderbookValues(orderBookRequest?.response?.orderBooks)?.map(
          (resp) => (
            <div className="mx-0.5">
              <OrderBookTable tableInfo={resp?.fullOrderBook} />
            </div>
          ),
        )}
      </div>
      <div
        className={`flex flex-row justify-start items-center gap-5 ${
          totalPricesBesideOrderbooks ? "shrink-0" : ""
        }`}
      >
        <div className="shrink-0 whitespace-nowrap">بهای تمام شده:</div>

        {orderBookRequest?.response?.totalPrices?.map((totalPrice, tI) => (
          <div className="flex flex-row justify-start items-center">
            {totalPrice?.ratios?.map((r, i) => (
              <>
                <div
                  className={`${
                    r.orderSide === StepOrderSide.Buy
                      ? "text-green-700"
                      : r.orderSide === StepOrderSide.Sell
                        ? "text-red-700"
                        : "text-gray-600"
                  }`}
                >
                  {r.ratio}
                </div>
                {totalPrice.ratios.length !== i + 1 ? (
                  <>-</>
                ) : (
                  <div
                    className={`mr-5 ltr ${
                      orderBookRequest?.response?.totalPrices.length !== tI + 1
                        ? "border-l-[1px] border-gray-600 pl-5"
                        : ""
                    }`}
                  >
                    {addSeperatorToInput(totalPrice.price, "priceWithDecimal")}
                  </div>
                )}
              </>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Orderbook;
